import React from 'react';

function EnclosuresList({ yards = [] }) {
  const enclosures = [
    { title: 'PERT', values: Array(yards.length).fill(1) },
    { title: 'Status of approvals', values: Array(yards.length).fill(2) },
    { title: 'Status of 3DCAD Model and CLOs', values: Array(yards.length).fill(3) },
    { title: 'Status of MDL procured Project Equipment', values: Array(yards.length).fill(4) },
    { title: 'Status of delayed Project Equipment', values: Array(yards.length).fill(5) },
    { title: 'Details of Steel Procurement', values: Array(yards.length).fill(6) }
  ];

  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold mb-4 text-gray-800">List of Enclosures:</h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2 text-left sticky left-0 bg-gray-100 z-10 min-w-[250px]">
                Title of Enclosure
              </th>
              {yards.map((yard, index) => (
                <th 
                  key={index} 
                  className="border border-gray-300 p-2 text-center whitespace-nowrap"
                >
                  {yard}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {enclosures.map((item, index) => (
              <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                <td className="border border-gray-300 p-2 sticky left-0 bg-white z-10">
                  {item.title}
                </td>
                {item.values.map((value, i) => (
                  <td key={i} className="border border-gray-300 p-2 text-center">
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default EnclosuresList;